import { connect } from 'react-redux';
// import Report from '../../components/digital_rating/Report';
import MainPersonal from '../../components/dashboard/main_personalMTO/MainPersonal';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPersonal);
